import React from "react";

const Specifications = ({ 
        dataset = [],
        cols = 3
    }) => {
        return (
            <div className={`specifications col-${cols}`}>
                {dataset.map((item, index) => {
                    return (
                        <div className={item.gold ? "gold-border" : ""} key={index}>
                            <h4>{item.name}</h4>
                            <p>{item.title}</p>
                            <div className="specifications-stack">
                                {item.stack && item.stack.map((stack, key) => {
                                    return <p className="text" key={key}>{stack}</p>
                                })}
                            </div>
                        </div>
                    )
                })}
            </div>
        );
};

export default Specifications;